export const INBOUND_MANIFEST_TYPES = ['WILL_CALL', 'INBOUND', 'CROSS_DOCK'];

export const getInboundManifests = (order) => {
    const manifests = {};
    (order?.itemsByOrderId || []).forEach((item) => {
        (item.manifests || []).forEach((manifestMapping) => {
            if (manifestMapping.manifest && INBOUND_MANIFEST_TYPES.includes(manifestMapping.manifest.type)) {
                const manifestId = manifestMapping.manifest.manifest_id;
                if (!manifests[manifestId]) {
                    manifests[manifestId] = {
                        ...manifestMapping.manifest,
                        items: [],
                    };
                }
                const { manifest, ...rest } = manifestMapping;
                manifests[manifestId].items.push({
                    ...rest,
                    item: { ...item, order },
                });
            }
        });
    });
    return Object.values(manifests);
};

export const getWarehouseManifestNumber = (order) => {
    const numbers = [...new Set(getInboundManifests(order).map((manifest) => manifest.reference_id).filter(Boolean))];
    if (numbers.length) {
        return numbers.join(', ');
    }

    return order?.warehouse_manifest_number || null;
};
